// import React from 'react';
// import NavManagement from '../components/NavManagements'
// import Navbar from '../components/Navbar';
// import Footer from '../components/Footer';
// import Sidebar from '../components/Sidebar';

// const NavManagementPage = () => {
//   return (
//     <div>
//       <Navbar />
//       <Sidebar/>
//       <div style={{ paddingTop: '70px' }}>
//       <NavManagement />
//       </div>
//       <Footer />
//     </div>
//   );
// };

// export default NavManagementPage;

// import React from 'react';
// import NavManagement from '../components/NavManagements';
// import Navbar from '../components/Navbar';
// import Footer from '../components/Footer';
// import Sidebar from '../components/Sidebar';

// const NavManagementPage = () => {
//   return (
//     <div>
     
//       <div style={{ display: 'flex' }}>
//         <Sidebar />
//         <div style={{ marginLeft: '250px', flex: 1 }}>
//         <Navbar />
//           <NavManagement />
//         </div>
//       </div>
//       <Footer />
//     </div>
//   );
// };

// export default NavManagementPage;

import React, { useState, useEffect } from 'react';
import NavManagement from '../components/NavManagements';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Sidebar from '../components/Sidebar';

const NavManagementPage = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  // Handle window resizing for responsiveness
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setIsSidebarOpen(false); // Collapse sidebar on small screens
      } else {
        setIsSidebarOpen(true); // Expand sidebar on larger screens
      }
    };

    // Add event listener for resize
    window.addEventListener('resize', handleResize);

    // Check initial window size
    handleResize();

    // Clean up the event listener on component unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div>
      <div >
        {/* Pass the isSidebarOpen state to Sidebar */}
        <Sidebar isOpen={isSidebarOpen} toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />
        <div
          style={{
            marginLeft: isSidebarOpen ? '250px' : '0', // Adjust margin based on sidebar state
            flex: 1,
            transition: 'margin-left 0.3s ease', // Smooth transition when sidebar toggles
            paddingTop: '70px', // Ensure content isn't hidden behind fixed navbar
          }}
        >
          <Navbar />
          <NavManagement />
          {/* <Footer /> */}

        </div>
      </div>
    </div>
  );
};

export default NavManagementPage;

// import React, { useState, useEffect, useRef } from 'react';
// import NavManagement from '../components/NavManagements';
// import Navbar from '../components/Navbar';
// import Footer from '../components/Footer';
// import Sidebar from '../components/Sidebar';

// const NavManagementPage = () => {
//   const [isSidebarOpen, setIsSidebarOpen] = useState(true);
//   const sidebarRef = useRef(null);

//   // Handle window resizing for responsiveness
//   useEffect(() => {
//     const handleResize = () => {
//       if (window.innerWidth <= 768) {
//         setIsSidebarOpen(false); // Collapse sidebar on small screens
//       } else {
//         setIsSidebarOpen(true); // Expand sidebar on larger screens
//       }
//     };

//     // Add event listener for resize
//     window.addEventListener('resize', handleResize);

//     // Check initial window size
//     handleResize();

//     // Clean up the event listener on component unmount
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   // Close the sidebar if clicked outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
//         setIsSidebarOpen(false); // Collapse sidebar if clicked outside
//       }
//     };

//     // Add event listener for clicks outside the sidebar
//     document.addEventListener('mousedown', handleClickOutside);

//     // Clean up the event listener on component unmount
//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, []);

//   return (
//     <div>
//       <div style={{ display: 'flex' }}>
//         {/* Pass the isSidebarOpen state to Sidebar */}
//         <Sidebar ref={sidebarRef} isOpen={isSidebarOpen} toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />
//         <div
//           style={{
//             marginLeft: isSidebarOpen ? '250px' : '0', // Adjust margin based on sidebar state
//             flex: 1,
//             transition: 'margin-left 0.3s ease', // Smooth transition when sidebar toggles
//             paddingTop: '70px', // Ensure content isn't hidden behind fixed navbar
//           }}
//         >
//           <Navbar />
//           <NavManagement />
//         </div>
//       </div>
//       <Footer />
//     </div>
//   );
// };

// export default NavManagementPage;


